module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-202.a1e6d1e.woff2";